import "./ScheduleSection.css";

function ScheduleSection({
  formData,
  updateField,
}) {
  return (
    <div className="food-form-section">

      <h3 className="section-title">
        Availability Schedule
      </h3>

      <div className="schedule-grid">

        {/* Available From */}

        <div className="form-group">

          <label>
            Available From
          </label>

          <input
            type="time"
            value={formData.availableFrom}
            onChange={(e) =>
              updateField(
                "availableFrom",
                e.target.value
              )
            }
          />

        </div>

        {/* Available To */}

        <div className="form-group">

          <label>
            Available To
          </label>

          <input
            type="time"
            value={formData.availableTo}
            onChange={(e) =>
              updateField(
                "availableTo",
                e.target.value
              )
            }
          />

        </div>

      </div>

      <div className="schedule-note">

        <strong>Note:</strong> Leave both fields empty if this food is
        available throughout the day.

      </div>

    </div>
  );
}

export default ScheduleSection;